var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropper"},[_c('input',{attrs:{"type":"file","multiple":"","accept":"image/*"},on:{"change":function($event){return _vm.uploadImages($event.target.files)}}}),_c('span',[_vm._v("Drag files here!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }